import { render, staticRenderFns } from "./maxweb.vue?vue&type=template&id=1231f278&scoped=true"
import script from "./maxweb.vue?vue&type=script&lang=js"
export * from "./maxweb.vue?vue&type=script&lang=js"
import style0 from "./maxweb.vue?vue&type=style&index=0&id=1231f278&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1231f278",
  null
  
)

export default component.exports